// Author liang gang qiang
// Date 2023-10-18 11:08:01

import * as model from "@/model/sithMesII/plan/SithMomMainProjectTemplateModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMomMainProjectTemplate(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMESII_PLAN_URL,
    })
    .buildStore()
